// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"ChartSelector_thumbnail__2ySvO","currentChart":"ChartSelector_currentChart__2XRQL","disabled":"ChartSelector_disabled__3UrP-"};